import React from 'react';
import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatologueEntry"
import DataCache from "../../StaticData/StaticDataCache";
import { IGeneralApiClient } from "../../../Common/ApiClients/GeneralApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles"
import StaticTaxTypeLookup from '../../../Common/Models/StaticTaxTypeLookup';

export default class StaticTaxTypeEntry extends CatalogueEntry<StaticTaxTypeLookup> {

    constructor() {
        super("Tax Type", StaticTaxTypeLookup);
    }

    public get editRole() {
        return Roles.CatalogueRoles.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.taxType;
    }
    
    public getSaveEndpoint(apiClient: IGeneralApiClient) {
        return apiClient.saveTaxTypes;
    }
    
    public renderRow(item: StaticTaxTypeLookup, meta: Model.TransformMetaType<StaticTaxTypeLookup>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.taxDescription} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}